import { Game } from '../game/Game';
import { UserProfil } from '../profil/UserProfil';

export class GameProfil {
  constructor(public readonly game: Game, public readonly profil?: UserProfil) {}
}
